/*
 *
 * DashboardFilters reducer
 *
 */
import produce from 'immer';
import moment from 'moment';

import { DEFAULT_DATE_OPTIONS } from 'utils/constants';
import {
  DEFAULT_ACTION,
  UPDATE_FILTERS,
  SET_ACTIVE_NAVIGATION,
} from './constants';

// import { rest } from 'lodash';

export const initialState = {};

/* eslint-disable default-case, no-param-reassign */
const dashboardFiltersReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case SET_ACTIVE_NAVIGATION: {
        draft.activeNavigation = action.data;

        draft.appliedFilters = {
          fromDate: moment().format('YYYY-MM-DD'),
          toDate: moment().format('YYYY-MM-DD'),
        };
        // eslint-disable-next-line prefer-destructuring
        draft.dateFilters = DEFAULT_DATE_OPTIONS[0];
        draft.filtersForDislay = {};
        break;
      }
      case UPDATE_FILTERS: {
        const { data } = action;
        if (data.appliedFilters) {
          draft.appliedFilters = data.appliedFilters;
          const { fromDate, toDate, ...rest } = data.appliedFilters;
          if (data.applyFilter) draft.filtersForDislay = rest;
        }
        if (data.dateFilters) draft.dateFilters = data.dateFilters;
        break;
      }
      case DEFAULT_ACTION:
        break;
    }
  });

export default dashboardFiltersReducer;
